import { render, staticRenderFns } from "./ProductDropdownMenu.vue?vue&type=template&id=2fa6b17e&"
import script from "./ProductDropdownMenu.vue?vue&type=script&lang=js&"
export * from "./ProductDropdownMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports